import Phaser from "phaser";
import LoadingScene from "@/games/Workspace/scenes/LoadingScene";
import LandingScene from "@/games/Workspace/scenes/LandingScene";
import Workspace from "@/games/Workspace/scenes/Workspace";


function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      LandingScene,
      Workspace,
    ],
  });
}

export default launch;
export { launch };
